import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { Global } from "@emotion/react";
import { ModalsProvider, SaasProvider } from "@saas-ui/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { Router } from "./Router";
import { theme } from "./theme";

import "./assets/fonts/FSIrwin-Regular.otf";
import { Fonts } from "./components/Fonts";

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
});

const GlobalStyles = `
  @font-face {
    font-family: 'FSIrwin Regular';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('./assets/fonts/FSIrwin-Regular.otf') format('opentype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
    box-shadow: none;
  }

  span,
  p,
  li {
    text-align: left;
  }

  body, #root {
    height: 100vh;
    background: white;
  }

  // Force saas-ui border-colour
  .css-x8n6o5, .css-r9bsox {
    // border-color: rgb(84, 86, 90) !important
  }
`;

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={theme}>
      <SaasProvider theme={theme}>
        <Fonts />
        <ColorModeScript initialColorMode="light" />
        <ModalsProvider>
          <Global styles={GlobalStyles} />
          <BrowserRouter>
            <AuthProvider>
              <Router />
            </AuthProvider>
          </BrowserRouter>
        </ModalsProvider>
      </SaasProvider>
    </ChakraProvider>
  </QueryClientProvider>
);
